module.exports = __webpack_public_path__ + "img/ip.2cae551c.png";